import { render, staticRenderFns } from "./Freight.vue?vue&type=template&id=4867a701"
import script from "./Freight.vue?vue&type=script&lang=js"
export * from "./Freight.vue?vue&type=script&lang=js"
import style0 from "./Freight.vue?vue&type=style&index=0&id=4867a701&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports